import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'
import type { Coupon, MetaShortDTO } from 'shared/types/api'

export type State = {
    coupons: Array<Coupon>,
    maxDisplay: number,
    addCouponSuccess: ?boolean,
    addCouponError: ?string,
    showTuto: boolean,
    dataLoaded: ?boolean,
    privilegesError?: any,
    privilegesNetworkError?: any,
    metaData?: MetaShortDTO
}

const initialState: State = {
    coupons: [],
    maxDisplay: 4,
    addCouponSuccess: undefined,
    addCouponError: undefined,
    showTuto: false,
    dataLoaded: undefined
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_PRIVILEGES_RESPONSE':
            return {
                ...state,
                ...action.data,
                showTuto: false,
                dataLoaded: true,
                privilegesError: undefined,
                privilegesNetworkError: undefined
            }
        case 'PAGE_DATA_DASHBOARD_RESPONSE':
            return {
                ...state,
                coupons: action.data.coupons,
                dataLoaded: true
            }
        case 'PAGE_DATA_DEALS_RESPONSE':
            return {
                ...state,
                coupons: action.dealsPage.kingdomCoupons
            }
        case 'PRIVILEGES_ADD_COUPON_SUCCESS':
            return {
                ...state,
                addCouponSuccess: true,
                addCouponError: null,
                coupons: action.coupons
            }
        case 'PRIVILEGES_ADD_COUPON_ERROR':
            return {
                ...state,
                addCouponSuccess: false,
                addCouponError: action.addCouponError
            }
        case 'PRIVILEGES_RESET_ADD_COUPON_SUCCESS':
            return {
                ...state,
                addCouponSuccess: false,
                addCouponError: null
            }
        case 'SIGNIN_SEND_FORM_SUCCESS':
        case 'SOCIAL_PENDING':
        case 'SIGNUP_SEND_FORM_SUCCESS':
            return {
                ...state,
                privilegesError: undefined
            }
        case 'LOGOUT':
            return {
                ...initialState,
                showTuto: state.showTuto
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.kingdom.privileges.page,
                'privilegesError'
            )
        case 'PRIVILEGES_ERROR':
            return {
                ...state,
                privilegesError: action.privilegesError
            }
        case 'PAGE_API_AUTH_ERROR':
            return {
                ...state,
                privilegesError: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                privilegesNetworkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                privilegesNetworkError: action.networkError,
                privilegesError: undefined
            }
        case 'PRIVILEGES_COUPONS':
            return {
                ...state,
                coupons: action.coupons
            }
        case 'UNTRANSFORM_POINTS_SUCCESS':
            const { couponCode } = action
            const updatedCoupons = state.coupons.filter(
                coupon => coupon.id !== couponCode
            )
            return {
                ...state,
                coupons: updatedCoupons
            }
        default:
            return state
    }
}
